import mapValues from 'lodash/mapValues';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';

export const syncFieldsIssueTypes =
	(): Action<State, Props> =>
	({ setState, getState }, { issueTypeIds = [] }) => {
		setState({
			fields: mapValues(getState().fields, (field) => ({
				...field,
				issueTypes: issueTypeIds,
			})),
		});
	};
